export default "__VITE_ASSET__CsS2Wk21__"